import { useNavigate, useLocation } from 'react-router-dom';
import { D, fmtAmt, type OrderListItem } from '@wave/shared';
import { StatusBadge } from './StatusBadge';
import { ProgressBar } from './ProgressBar';
import {
  tableCell,
  tableCellNum,
  tableCls,
  tableHead,
  tableHeadCell,
  tableHeadCellRight,
  tableRow,
  tableWrapper,
} from '../lib/styles';

interface Props {
  orders: OrderListItem[];
}

export function OrdersTable({ orders }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  function open(id: string) {
    navigate(`/orders/${id}`, { state: { backgroundLocation: location } });
  }

  return (
    <div className={tableWrapper}>
      <table className={tableCls}>
        <thead>
          <tr className={tableHead}>
            <th className={tableHeadCell}>ID</th>
            <th className={tableHeadCell}>Клиент</th>
            <th className={tableHeadCell}>Исполнитель</th>
            <th className={tableHeadCellRight}>Отдаём</th>
            <th className={tableHeadCellRight}>Получаем</th>
            <th className={tableHeadCellRight}>Профит</th>
            <th className={tableHeadCell}>Прогресс</th>
            <th className={tableHeadCell}>Оператор</th>
            <th className={tableHeadCell}>Статус</th>
            <th className={tableHeadCell}>Дата</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 && (
            <tr>
              <td colSpan={10} className="px-3 py-12 text-center text-sm text-text2">
                Нет заявок
              </td>
            </tr>
          )}
          {orders.map((o) => {
            const isReject = o.status === 'reject';
            const isLoss = !isReject && D(o.profitAmount).isNegative();
            return (
              <tr
                key={o.id}
                className={`row-clickable ${tableRow}`}
                onClick={() => open(o.id)}
              >
                <td className={`${tableCell} font-mono font-semibold text-accent`}>{o.id}</td>
                <td className={`${tableCell} font-medium text-text`}>{o.client}</td>
                <td className={`${tableCell} font-medium text-text`}>{o.executor}</td>
                <td className={tableCellNum}>{fmtAmt(o.clGiveAmt, o.clGiveCcy)}</td>
                <td className={tableCellNum}>{fmtAmt(o.clGetAmt, o.clGetCcy)}</td>
                <td
                  className={`${tableCellNum} font-semibold ${
                    isReject ? 'text-text2' : isLoss ? 'text-danger' : 'text-success'
                  }`}
                >
                  {isReject ? (
                    '—'
                  ) : (
                    <>
                      {fmtAmt(o.profitAmount, 'USDT')}
                      {o.profitNativeAmount &&
                        o.profitNativeCcy &&
                        !D(o.profitNativeAmount).isZero() && (
                          <div className="mt-0.5 text-[10px] font-normal text-text2">
                            ≈ {fmtAmt(o.profitNativeAmount, o.profitNativeCcy)}
                          </div>
                        )}
                    </>
                  )}
                </td>
                <td className={tableCell}>
                  {isReject ? <span className="text-text2">—</span> : <ProgressBar done={o.progress} />}
                </td>
                <td className={`${tableCell} font-mono text-xs text-text2`}>{o.operator}</td>
                <td className={tableCell}>
                  <StatusBadge status={o.status} />
                </td>
                <td className={`${tableCell} font-mono text-xs text-text2`}>{o.date}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
